// extracted by mini-css-extract-plugin
export default {"company-date":"Experience_company-date__cBMEf","experienceContainer":"Experience_experienceContainer__2i8PJ","bubble":"Experience_bubble__fv7ul"};